import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

//? gets user's time zone in string format (e.g. '+3',  '-5')
const UTCOffsetText = () => {
  const { t } = useTranslation();
  const offsetInHours = moment().utcOffset() / 60;
  const sign = offsetInHours >= 0 ? '+' : '';

  return (
    <>
      {t('UTC')} {sign}
      {offsetInHours}
    </>
  );
};

export default UTCOffsetText;
